export const Apiurl = process.env.REACT_APP_API_URL || "https://plataformageohcx.cloud/api/";

